import { useState } from 'react'
import {
   Button,
   ContentCard,
   Grid,
   Group,
   Select,
   Stack,
} from '@forwardflow/ui-v2'
import {
   ArrowLeftMdIcon,
   CloseIcon,
   SearchMagnifyingGlassIcon,
} from '@forwardflow/icons'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { FILTER_LABEL_MAP } from '@forwardflow/constants/onboarding.constants'

export const FilterConfirmation = ({
   setStep,
   selectedFilterId,
}: {
   setStep: (step: number) => void
   selectedFilterId: string
}) => {
   const {
      onboardingData,
      setFirstFilterCriteria,
      stages,
      tags,
      sources,
      ponds,
   } = useOnboardingStoreV2()

   const selectedValues =
      onboardingData?.campaignConfiguration?.campaign_filters
         ?.eligible_criteria[0].value || []
   const [selectedOptions, setSelectedOptions] =
      useState<Array<string | number>>(selectedValues)

   const [selectedValueId, setSelectedValueId] = useState<string | null>(null)
   const handleOptionSelect = (option: string) => {
      setSelectedOptions((prev) => [...prev, option])
      setSelectedValueId(null)
   }
   const handleOptionRemove = (option: string) => {
      setSelectedOptions((prev) => prev.filter((o) => o !== option))
   }

   const handleConfirmSelection = () => {
      setFirstFilterCriteria({
         field: selectedFilterId as
            | 'source'
            | 'stage'
            | 'tags'
            | 'assigned_pond_id',
         value: selectedOptions.map((option) => option as string),
         logic: 'AND',
         operator: 'CONTAINS_ANY',
      })
      setStep(3)
   }

   const dataMap = {
      source: sources,
      stage: stages.map((stage) => stage.name),
      tags: tags,
      assigned_pond_id: ponds,
   }

   return (
      <ContentCard className="space-y-4">
         <p className="text-white font-semibold text-lg">
            Which leads do you want Forward Flow to work on first?
         </p>
         <Select
            value={selectedValueId}
            key={selectedFilterId}
            onChange={(value: string | null) => handleOptionSelect(value || '')}
            label={`Select the ${
               FILTER_LABEL_MAP[
                  selectedFilterId as keyof typeof FILTER_LABEL_MAP
               ]
            } you'd like to include.`}
            leftSection={<SearchMagnifyingGlassIcon width={16} />}
            placeholder={`Search and select ${
               FILTER_LABEL_MAP[
                  selectedFilterId as keyof typeof FILTER_LABEL_MAP
               ]
            }`}
            data={dataMap[selectedFilterId as keyof typeof dataMap] || []}
         />
         {selectedOptions.length > 0 && (
            <Stack>
               {selectedOptions.map((option, index) => (
                  <Group
                     key={index}
                     justify="space-between"
                     className="rounded-[8px] border border-[#A684FF]/30 bg-[#A684FF]/10 py-3 px-4"
                  >
                     <p className="text-white font-inter text-sm font-medium">
                        {option}
                     </p>
                     <CloseIcon
                        width={16}
                        height={16}
                        className="cursor-pointer"
                        onClick={() => handleOptionRemove(option as string)}
                     />
                  </Group>
               ))}
            </Stack>
         )}
         <Grid>
            <Grid.Col span={3}>
               <Button
                  variant="secondary"
                  className="w-full"
                  onClick={() => setStep(1)}
               >
                  <ArrowLeftMdIcon width={12} /> Back
               </Button>
            </Grid.Col>
            <Grid.Col span={9}>
               <Button
                  className="w-full"
                  disabled={selectedOptions.length === 0}
                  onClick={() => handleConfirmSelection()}
               >
                  Confirm Selection
               </Button>
            </Grid.Col>
         </Grid>
      </ContentCard>
   )
}
